<template>
    <aside class="menu">
        <h3 class="menu-label">Überblick</h3>
        <div class="tags lines" style="display:none;">
            <template v-for="line in possibleLines">
                <input type="checkbox" :id="line" v-model="checkedLines" :value="line" @change="updateCheckboxes($event, 'Lines')">
                <label v-bind:class="{'is-link': checkedLines.indexOf(line)!=-1}" :for="line" class="tag">{{line}}</label>
            </template>
        </div>
        <div class="tags" v-if="this.$route.query['internal-view'] == 'true'">
            <input type="checkbox" id="api" v-model="checkedTags" value="api" @change="updateCheckboxes($event, 'Tags')">
            <label v-bind:class="{'is-link': checkedTags.indexOf('api')!=-1}" for="api" class="tag">API-generated</label>
            <input type="checkbox" id="aufbereiter" v-model="checkedTags" value="aufbereiter" @change="updateCheckboxes($event, 'Tags')">
            <label v-bind:class="{'is-link': checkedTags.indexOf('aufbereiter')!=-1}" class="tag" for="aufbereiter">Aufbereiter</label>
            <input type="checkbox" id="ergaenzer" v-model="checkedTags" value="ergaenzer" @change="updateCheckboxes($event, 'Tags')">
            <label v-bind:class="{'is-link': checkedTags.indexOf('ergaenzer')!=-1}" for="ergaenzer" class="tag">Ergänzer</label>
            <input type="checkbox" id="erklaerer" v-model="checkedTags" value="erklaerer" @change="updateCheckboxes($event, 'Tags')">
            <label v-bind:class="{'is-link': checkedTags.indexOf('erklaerer')!=-1}" for="erklaerer" class="tag">Erklärer</label>
        </div>
        <ul class="menu-list">
            <li v-for="article in sortedArticles">
                <a v-bind:class="{'is-active': activeArticle.urn==article.urn}" v-on:click="$emit('update:activeArticle', article)"><i class="star" v-if="article['embed-infos']['importance']=='top'">&#9733;</i> {{article.headline}}</a>
            </li>
        </ul>
    </aside>
</template>

<script>

export default {
    name: "ListOverview",
    props: {
        ArticleList: Array,
        activeArticle: Object
    },
    data: function(){
        return {
            possibleTags: ["api", "aufbereiter", "ergaenzer", "erklaerer"],
            checkedTags: ["api", "aufbereiter", "ergaenzer", "erklaerer"],
            possibleLines: ["infoline_rs", "serviceline", "sportsline", "starline", "labline"],
            checkedLines: ["infoline_rs", "serviceline", "sportsline", "starline", "labline"],
        };
    },
    computed: {
        sortedArticles: function(){
            let list = this.ArticleList;

            //Filter by chart-type
            /**list = list.filter(d => {
                try{
                    return this.checkedTags.indexOf(d["embed-infos"]["charttype"]) != -1;
                }catch(e){
                    return false;
                }
            });

            //Filter by line
            list = list.filter(d => {
                try{
                    let rubrics = d.rubric_names.map(e=>e.split(".")[1]);
                    return new Set(rubrics.concat(this.checkedLines)).size < (new Set(rubrics).size+new Set(this.checkedLines).size);
                }catch(e){
                    return false;
                }
            });*/

            list = list.map(d => {
                if(!d["embed-infos"]) d["embed-infos"] = {}

                return d
            })

            
            if(list.length == 0){
                //HOTFIX
                //TODO: Beautify / add tags for lines and functions
                list = this.ArticleList;
                this.checkedTags = this.possibleTags;
            }


            let sortedList = list.slice().sort((a, b) => {
                try{
                    if(a["embed-infos"]["importance"] == "top"){
                        if(b["embed-infos"]["importance"] == "top"){
                            return new Date(b.version_created) - new Date(a.version_created);
                        }else{
                            return -1;
                        }
                    }else if(b["embed-infos"]["importance"] == "top"){
                        return 1;
                    }
                    return new Date(b.version_created) - new Date(a.version_created);
                }catch(e){
                    return -1
                }
            });

            if(sortedList.filter(d=>this.activeArticle.urn ==d.urn).length==0 && sortedList.length>0){
                this.$emit('update:activeArticle', sortedList[0]);
            }

            return sortedList; 
        }
    },
    methods: {
        updateCheckboxes: function(event, checkboxListKey) {
            //Workaround overwriting default checkbox behaviour to keep at least one element active
            let selectedVal = event.target.value;
            if(this["checked"+checkboxListKey].length == this["possible"+checkboxListKey].length-1 
                && this["checked"+checkboxListKey].indexOf(selectedVal)==-1
                && event.target.checked == false){
                    //Line just got checked while all lines where active --> keep just this one active
                    this["checked"+checkboxListKey] = [selectedVal];
                    event.target.checked = true;
            }else if(this["checked"+checkboxListKey].length == 0){
                //Select all lines
                this["checked"+checkboxListKey] = this["possible"+checkboxListKey];
                event.target.checked = true;
            }
        }
    }
}

</script>

<style>
.menu{
    margin-top: 60px;
}

.menu-list{
    max-height: calc(100vh - 200px);
    overflow-x: auto;
}

.menu .tags{
    border-bottom: 1px solid #DDD;
}

label{
    -webkit-user-select:none;
    -khtml-user-select:none;
    -moz-user-select:none;
    -o-user-select:none;
    user-select:none;
}

a.is-active i.star{
    color: #FFF;
}

i.star{
    color: #3273dc;
    font-style: normal;
}

@media(max-width: 786px){
    .menu{
        margin-top: 15px;
    }
}

input{
    display: none;
}

label{
    cursor: pointer;
}
</style>